<app-data-setup-common-content [isIos]="false" [isTmo]="true"></app-data-setup-common-content>
<div class="android-tmo-container page-section">
    <section class="title-section">
        <div class="image-part">
            <img src="assets/icon/android-icon.svg" width="40" height="42" alt="Android Icon">
        </div>
        <h4>Android LTE Instructions:</h4>
    </section>
    <div class="info-banner default-background">
        <div class="flex">
            <img src="assets/icon/banner-info-icon.svg" width="32" height="32" alt="Info Icon">
            <div class="banner-content">
                <h5 class="title">Note:</h5>
                <p class="smaller desc-a">The following instructions are for most <b>Android devices</b>.</p>
                <p class="smaller desc-b">While your phone’s menu may look different, the information which goes into
                    each of the fields is the same, no matter what model device you have.</p>
                <p class="smaller desc-a last">No data connection is necessary when entering these settings but a
                    data-capable device is required to surf the web and watch videos online.</p>
            </div>
        </div>
    </div>
    <section class="instructions-section">
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-one-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Press <b>"Menu"</b> button on your device</p>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-two-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Tap <b>“Settings” > “Wireless Controls”</b> or <b>“Wireless and Network” > “Mobile Networks”</b></p>
        </div>
        <div class="info-banner warning-background">
            <div class="flex">
                <img src="assets/icon/banner-warning-icon.svg" width="32" height="32" alt="Warning Icon">
                <div class="banner-content">
                    <h5 class="title">Attention</h5>
                    <p class="smaller desc-a last">Make sure <b>“Data Roaming”</b> and <b>“Use Only 2G Networks”</b> are
                        both <b>UNCHECKED</b></p>
                </div>
            </div>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-three-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Tap <b>Access Point Names</b></p>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-four-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Press Menu button and select New <b>APN</b></p>
        </div>
        <div class="flex-text bottom">
            <div class="number-image">
                <img src="assets/icon/circle-five-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Enter the following information:</p>
        </div>
        <div class="information-part">
            <div class="box desktop">
                <div class="key-value-flex" *ngFor="let info of androidInfoDetails.slice(0, 8)">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value" *ngIf="!info.href">{{info.value}}</p>
                    <p class="smaller value" *ngIf="!!info.href"><a class="word-break"
                            href="http://wholesale.mmsmvno.com/mms/wapenc">{{info.value}}</a></p>
                </div>
            </div>
            <div class="box desktop">
                <div class="key-value-flex" *ngFor="let info of androidInfoDetails.slice(8)">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value">{{info.value}}</p>
                </div>
            </div>
            <div class="box responsive">
                <div class="key-value-flex" *ngFor="let info of androidInfoDetails">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value" *ngIf="!info.href">{{info.value}}</p>
                    <p class="smaller value" *ngIf="!!info.href"><a class="word-break"
                            href="http://wholesale.mmsmvno.com/mms/wapenc">{{info.value}}</a></p>
                </div>
            </div>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-six-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Press the <b>“Menu”</b> button on your device and then <b>“Save”</b> on the screen.</p>
        </div>
        <div class="flex-text last">
            <div class="number-image">
                <img src="assets/icon/circle-seven-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Go to <b>Account Summary</b> to manage your account</p>
        </div>
    </section>
    <div class="got-it-button">
        <button class="button primary" (click)="gotIt()">Got it</button>
    </div>
</div>